
import { defineComponent, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { MenuComponent } from "@/assets/ts/components";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { headerMenuIcons } from "@/core/helpers/config";
import { version } from "@/core/helpers/documentation";

export default defineComponent({
    name: "KTMenu",
    components: {},
    setup() {
        const { t, te } = useI18n();
        const route = useRoute();

        const hasActiveChildren = (match) => {
            return route.path.indexOf(match) !== -1;
        };

        const translate = (text) => {
            if (te(text)) {
                return t(text);
            } else {
                return text;
            }
        };

        onMounted(() => {
            MenuComponent.reinitialization();
        });

        return {
            hasActiveChildren,
            headerMenuIcons,
            MainMenuConfig,
            translate,
            version,
        };
    },
});
